import * as msal from "@azure/msal-browser";
const {
    REACT_APP_REDIRECT_URI,
    REACT_APP_TENANT,
    REACT_APP_CLIENT_ID,
    REACT_APP_SCOPE_ID_URI,
} = process.env;

export const msalConfig = {
    auth: {
        clientId: REACT_APP_CLIENT_ID ?? "",
        authority: "https://login.microsoftonline.com/"+(REACT_APP_TENANT??""),
        redirectUri: REACT_APP_REDIRECT_URI??""
    },
    cache: {
        cacheLocation: "localStorage"
    },
    system: {
        loggerOptions: {
            piiLoggingEnabled: false,
            logLevel: msal.LogLevel.Verbose,
        }
    }

};
// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    // scopes: ["api://86563b7f-87bb-4949-844a-af37beb87cab/User.Read","User.Read", "offline_access"]//api://86563b7f-87bb-4949-844a-af37beb87cab
    scopes: [REACT_APP_SCOPE_ID_URI,"User.Read", "offline_access"]//api://86563b7f-87bb-4949-844a-af37beb87cab
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};



